export default __webpack_public_path__ + "static/media/mappa-percorsi.527a5344.jpg";